/**
 * Triggers animation on scroll
 */

const scrollAnimation = function() {
  const targets = document.querySelectorAll("[data-scroll-animation]");

  // Intersection Observer OPTIONS
  const options = {
    root: null,
    threshold: 0,
  };

  // ---------------- Functions --------------- //

  const addAnimationSpeed = function(el) {
    el.style.transition = "all 1s";
  };

  const removeAnimationSpeed = function(el) {
    setTimeout(() => el.removeAttribute("style") , 1000);
  };

  // Intersection Observer CALLBACK
  const callback = function(entries) {
    const [entry] = entries;

    if (entry.isIntersecting) {
      addAnimationSpeed(entry.target);
      entry.target.classList.add("active");
      removeAnimationSpeed(entry.target);
    }
  };

  // Trigger animation if inside the screen.
  const displayAnimation = function() {
    targets.forEach(target => {
      const position = target.getBoundingClientRect().top;

      if (position >= 0 && position <= window.innerHeight) {
        addAnimationSpeed(target);
        target.classList.add("active");
        removeAnimationSpeed(target);
      }
    });
  };

  // ---------------- Events ------------------ //

  // Intersection Observer
  const animationObserver = new IntersectionObserver(callback, options);
  targets.forEach(target => animationObserver.observe(target));

  // Trigger animation on LOAD
  window.addEventListener("load", displayAnimation);

  // Trigger animation AFTER SCROLLING
  window.addEventListener("scrollend", displayAnimation);
}

export default scrollAnimation;